import { useOutletContext } from "react-router-dom";
import { VENDOR_ADMIN, VENDOR, SUPER_ADMIN } from "@/shared/constants/roles";

type Role = typeof VENDOR_ADMIN | typeof VENDOR | typeof SUPER_ADMIN;

type OutletContextType = {
  authLoading: boolean;
  profileData: any;
  profileLoading: boolean;
  profileIsError: boolean;
  profileError: unknown;
  profileFetchStatus: string;
  profileRefetch: () => void;
  authData:
    | undefined
    | {
        "https://api.storemandu.com/internal"?: Role;
        "https://api.storemandu.com/stores"?: {
          [storeId: string]: {
            role: Role;
            slug: string | null;
            status: string;
          };
        };
        "https://api.storemandu.com/defaultStoreId"?: string;
        given_name?: string;
        family_name?: string;
        nickname?: string;
        name?: string;
        picture?: string;
        updated_at?: string;
        email?: string;
        email_verified?: boolean;
        sub?: string;
      };
  authLogout: () => void;
  isNotificationOpen: boolean;
  openNotification: () => void;
  closeNotification: () => void;
};

export default function useMisc() {
  const context = useOutletContext<OutletContextType>();
  return context;
}
